var _tspan, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598.032,
    height: 407.925,
    viewBox: "0 0 158.229 107.93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "Unispace"
    },
    x: 51.803,
    y: 98.575,
    transform: "matrix(.87838 0 0 1.13846 -48.017 -4.293)",
    fontWeight: 400,
    fontSize: 43.375,
    fontFamily: "Unispace",
    fill: "#fff",
    strokeWidth: 0.301
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 51.803,
    y: 98.575
  }, "DreamPix"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.175,
    d: "M47.618 1.588h60.008v60.008H47.618z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4.233,
    d: "M69.647 23.869h36.967v36.967H69.647z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logoVertical.eab547bab8ea8e6e3b0fed6640457912.svg";
export { ForwardRef as ReactComponent };